import { useRuntimeConfig } from 'nuxt/app'

export const useDexTradesStore = defineStore('dexTrades', () => {
  const axios = useAxios()
  const { MIDDLEWARE_URL } = useRuntimeConfig().public
  const { price } = storeToRefs(useMarketStatsStore())

  const rawTrades = ref(null)

  const trades = computed(() => rawTrades.value && price.value
    ? adaptTrades(rawTrades.value, price.value)
    : null,
  )

  async function fetchDexTrades({ queryParameters, limit } = {}) {
    rawTrades.value = null
    const effectiveLimit = limit || 10
    const defaultParameters = `/dex/swaps?limit=${effectiveLimit}`
    const { data } = await axios.get(`${MIDDLEWARE_URL}${queryParameters || defaultParameters}`)
    rawTrades.value = data
  }

  return {
    fetchDexTrades,
    trades,
  }
})
